// extracted by mini-css-extract-plugin
module.exports = {"_subInfo":"BestelldatenView__subInfo__2WI2b"};